<template>
  <div class="voice-room-dressup" v-show="visible" @click.stop>
    <div class="main">
      <div class="header">
        <div
          class="avatar-box"
          v-if="selectItem.dressupType === 'AVATAR_FRAME'"
        >
          <img
            class="avatar"
            :src="$util.setImageSize(avatarUrl, 100, 100)"
            alt=""
            v-if="avatarUrl"
          />
          <img
            class="img-dressup"
            :src="
              selectItem.dressupType === 'MOUNT'
                ? selectItem.dressupIcon
                : selectItem.dressupUrl
            "
            alt=""
          />
        </div>
        <img
          class="img-dressup"
          :src="
            selectItem.dressupType === 'MOUNT'
              ? selectItem.dressupIcon
              : selectItem.dressupUrl
          "
          alt=""
          v-else
        />
        <div class="name">{{ selectItem.dressupName }}</div>
        <div
          class="describe"
          v-if="selectItem.isUse == 'NOT_OWN' && !selectItem.priceList"
        >
          {{ selectItem.ownConditionDesc }}
        </div>
        <div class="action" v-if="selectItem.isUse != 'NOT_OWN'">
          <button @click="releaseDressup()" v-if="selectItem.isUse == 'IN_USE'">
            取消穿戴
          </button>
          <button @click="useDressup()" v-else>
            穿戴
          </button>
        </div>
        <div
          class="price-box"
          v-if="
            selectItem.isUse == 'NOT_OWN' && priceList && priceList.length > 0
          "
        >
          <div
            v-for="(item, index) of priceList"
            class="price-item"
            :class="{ active: priceIndex == index }"
            :key="index"
            @click="selectPrice(index)"
          >
            <div>
              <span class="days">{{ item.days }}</span>
              <span>天</span>
            </div>
            <div class="price">
              <img
                class="img-diamond"
                src="~@/assets/image/icons/diamond.png"
                alt=""
              />
              <span class="price-value">{{ item.price }}</span>
            </div>
          </div>
        </div>
        <button
          class="btn-buy"
          v-if="
            priceIndex != null && selectItem.isUse == 'NOT_OWN' && priceList
          "
          @click="handleBuyDressup()"
        >
          购买
        </button>
      </div>
      <el-tabs class="tab-box" v-model="activeName" @tab-click="handleClick">
        <el-tab-pane label="頭像框" name="avatar">
          <dressup-list
            :list="avatarList"
            @select-dressup="selectDressup"
          ></dressup-list>
        </el-tab-pane>
        <el-tab-pane label="氣泡框" name="bubble">
          <dressup-list
            :list="bubbleList"
            @select-dressup="selectDressup"
          ></dressup-list>
        </el-tab-pane>
        <el-tab-pane label="入場橫幅" name="entry-banner">
          <dressup-list
            :list="entryBannerList"
            @select-dressup="selectDressup"
          ></dressup-list>
        </el-tab-pane>
        <el-tab-pane label="座騎" name="mount">
          <dressup-list
            :list="mountList"
            @select-dressup="selectMountDressup"
          ></dressup-list>
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
import dressupList from './dressup-list.vue';
import VoiceRoomVideoProvider from '@/components/VoiceRoom/videoProvider';

export default {
  name: 'Dressup',
  components: {
    dressupList
  },
  data() {
    return {
      activeName: 'avatar',
      avatarList: [],
      bubbleList: [],
      entryBannerList: [],
      mountList: [],
      visible: false,
      selectItem: {},
      priceIndex: null,
      buyLoading: false
    };
  },
  props: {
    roomId: {
      type: [String],
      default: ''
    }
  },
  computed: {
    ...mapGetters(['accountInfo', 'userInfo']),

    diamondBalance() {
      return this.accountInfo ? this.accountInfo.diamondBalance || 0 : 0;
    },
    balance() {
      return this.accountInfo ? this.accountInfo.balance || 0 : 0;
    },
    uuid() {
      return this.userInfo ? this.userInfo.uuid : '';
    },
    avatarUrl() {
      return this.userInfo ? this.userInfo.avatarUrl : '';
    },
    priceList() {
      if (this.selectItem) {
        return JSON.parse(this.selectItem.priceList);
      } else {
        return null;
      }
    }
  },
  methods: {
    init() {
      this.visible = true;
      this.activeName = 'avatar';
      if (!this.avatarList.length) {
        this.getAvatarList();
      } else {
        this.selectDressup(this.avatarList[0]);
      }
      this.addClickListener();
    },
    addClickListener() {
      this.$nextTick(() => {
        document.body.addEventListener('click', this.closeDialog);
      });
    },
    removeClickListener() {
      document.body.removeEventListener('click', this.closeDialog);
    },
    refresh() {
      if (this.activeName == 'avatar') {
        this.getAvatarList();
      }
      if (this.activeName == 'bubble') {
        this.getBubbleList();
      }
      if (this.activeName == 'entry-banner') {
        this.getEntryBannerList();
      }
      if (this.activeName == 'mount') {
        this.getMountList();
      }
      this.$store.dispatch('app/getUserInfo');
      this.$store.dispatch('app/getUserAccount');
    },
    closeDialog() {
      this.visible = false;
      this.$emit('close-dialog');
      document.body.removeEventListener('click', this.closeDialog);
    },
    handleClick() {
      if (this.activeName == 'avatar') {
        if (!this.avatarList.length) {
          this.getAvatarList();
        } else {
          this.selectDressup(this.avatarList[0]);
        }
      }
      if (this.activeName == 'bubble') {
        if (!this.bubbleList.length) {
          this.getBubbleList();
        } else {
          this.selectDressup(this.bubbleList[0]);
        }
      }
      if (this.activeName == 'entry-banner') {
        if (!this.entryBannerList.length) {
          this.getEntryBannerList();
        } else {
          this.selectDressup(this.entryBannerList[0]);
        }
      }
      if (this.activeName == 'mount') {
        if (!this.mountList.length) {
          this.getMountList();
        } else {
          this.selectDressup(this.mountList[0]);
        }
      }
    },
    async getAvatarList() {
      const { data } = await this.$http.post('dressup/getUserDressupInfo', {
        dressupType: 0
      });
      this.avatarList = data;
      this.selectDressup(data[0]);
    },
    async getBubbleList() {
      const { data } = await this.$http.post('dressup/getUserDressupInfo', {
        dressupType: 1
      });
      this.bubbleList = data;
      this.selectDressup(data[0]);
    },
    async getEntryBannerList() {
      const { data } = await this.$http.post('dressup/getUserDressupInfo', {
        dressupType: 2
      });
      this.entryBannerList = data;
      this.selectDressup(data[0]);
    },
    async getMountList() {
      const { data } = await this.$http.post('dressup/getUserDressupInfo', {
        dressupType: 3
      });
      this.mountList = data;
      this.selectDressup(data[0]);
    },
    selectMountDressup(item) {
      this.selectDressup(item);
      VoiceRoomVideoProvider.playNow(item.dressupUrl);
    },
    selectDressup(item) {
      console.log(item);
      this.selectItem = item;
      this.priceIndex = null;
    },
    selectPrice(index) {
      this.priceIndex = index;
    },
    async useDressup() {
      try {
        await this.$http.post('dressup/use', {
          dressupType: this.selectItem.dressupType,
          roomUid: this.roomId,
          userUuid: this.uuid,
          uuid: this.selectItem.uuid
        });
        this.refresh();
      } catch (error) {
        this.$message.error('穿戴失敗');
        console.log(error);
      }
    },
    async releaseDressup() {
      try {
        await this.$http.post('dressup/release', {
          dressupType: this.selectItem.dressupType,
          roomUid: this.roomId,
          userUuid: this.uuid,
          uuid: this.selectItem.uuid
        });
        this.refresh();
      } catch (error) {
        this.$message.error('取消穿戴失敗');
        console.log(error);
      }
    },
    async handleBuyDressup() {
      console.log('handleBuyDressup', this.diamondBalance);
      const { price } = this.priceList[this.priceIndex];
      if (this.buyLoading) {
        return;
      }
      try {
        if (this.diamondBalance > price) {
          this.buyDressup();
        } else {
          const coinPrice = Math.ceil((price - this.diamondBalance) / 15);
          this.removeClickListener();

          if (this.balance - coinPrice >= 0) {
            this.$confirm({
              content: `鑽石不足，是否花費${coinPrice}nicee幣購買鑽石`,
              title: '提示',
              showCancelButton: false,
              confirmButtonText: '確定',
              // cancelButtonText: '取消',
              closeOnClickOverlay: true
            }).then(async () => {
              try {
                await this.$http.post('/account/convertAccount', {
                  accountKind: 'Balance',
                  convertAccountKind: 'Diamond',
                  convertAmount: coinPrice,
                  userUuid: this.uuid
                });
                this.$store.dispatch('app/getUserAccount');
                this.addClickListener();
                await this.buyDressup();
              } catch (error) {
                this.addClickListener();
                this.$message.error('購買失敗');
              }
            });
          } else {
            this.$confirm({
              content: `餘額不足，是否去儲值`,
              title: '提示',
              showCancelButton: false,
              confirmButtonText: '確定',
              closeOnClickOverlay: true
            }).then(() => {
              this.addClickListener();
              window.open('/diamond-recharge', '_blank');
            });
          }
        }
      } catch (error) {
        this.buyLoading = false;
        this.$message.error('購買失敗');
        console.log(error);
      }
    },
    async buyDressup() {
      this.buyLoading = true;
      try {
        const { days } = this.priceList[this.priceIndex];
        await this.$http.post('dressup/buy', {
          days: days,
          userUuid: this.uuid,
          uuid: this.selectItem.uuid
        });
        this.buyLoading = false;
        this.useDressup();
      } catch (error) {
        this.buyLoading = false;
        this.$message.error('購買失敗');
        console.log(error);
      }
    }
  },
  created() {
    this.getAvatarList();
  }
};
</script>
<style lang="scss" scoped>
.voice-room-dressup {
  font-size: 0;
}
.header {
  min-height: 300px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  font-size: 20px;
  color: white;
  margin-bottom: 20px;
  .avatar-box {
    width: 160px;
    height: 160px;
    position: relative;
    .avatar {
      width: 100%;
      height: 100%;
      border-radius: 50%;
      object-fit: cover;
      transform: scale(0.7);
    }
    .img-dressup {
      width: 100%;
      height: auto;
      border-radius: 50%;
      object-fit: cover;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    }
  }
  img {
    width: 160px;
    height: auto;
  }
  .name {
    margin-top: 20px;
    margin-bottom: 20px;
  }
  .describe {
    font-size: 14px;
  }
  button {
    border-radius: 20px;
    background-color: #f72586;
    color: white;
    font-size: 14px;
    padding: 10px 20px;
    min-width: 160px;
  }
  .price-box {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    .price-item {
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;
      border-radius: 10px;
      background-color: #26273c;
      color: #a6a8b4;
      width: 118px;
      font-size: 14px;
      padding: 20px;
      cursor: pointer;
      + .price-item {
        margin-left: 10px;
      }
      &.active {
        border: 1px solid yellow;
      }

      .days {
        font-weight: bold;
        font-size: 20px;
      }
      .price {
        display: flex;
        align-items: center;
        margin-top: 8px;
        .img-diamond {
          width: 18px;
          margin-right: 4px;
        }
      }
    }
  }
  .btn-buy {
    margin-top: 20px;
  }
}
.main {
  width: 100%;
  position: absolute;
  bottom: 0;
  left: 0;
  background-color: rgb(0, 0, 0);
  display: flex;
  justify-content: center;
  flex-direction: column;
  padding: 4px 20px 20px;
  border-radius: 6px;
  .tab-box {
    /deep/ .el-tabs__header {
      padding-left: 24px;
    }
  }
}
</style>
<style lang="scss">
.voice-room-dressup {
  .el-tabs__nav-wrap::after {
    display: none;
  }
  .el-tabs__item {
    color: white;
    &.is_active {
      color: yellow;
    }
  }
  .el-loading-mask {
    background: none;
  }
}
</style>
